import { render, staticRenderFns } from "./ServerMultipleSelect2.vue?vue&type=template&id=2995ea51"
import script from "./ServerMultipleSelect2.vue?vue&type=script&lang=js"
export * from "./ServerMultipleSelect2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports